import React from 'react';
import { formatPeriodLabel } from '../submissions/periodFormat';

const num = (v) => (v == null ? '—' : Number(v).toLocaleString('en-US'));

// PostgREST returns the pi_rewards embed as a single object (submission_id is
// UNIQUE → detected one-to-one), but older/other setups may return an array.
// Normalize so the Reward cell reads the amount either way.
const rewardOf = (r) =>
  (Array.isArray(r.pi_rewards) ? r.pi_rewards[0] : r.pi_rewards) || null;

export function ApprovedPerformanceList({ rows, page, pageCount, onPage, onDetail }) {
  if (!rows || rows.length === 0) {
    return <p className="submissions-empty">No approved Performance Data matches these filters.</p>;
  }
  return (
    <>
      <table className="submissions-table">
        <thead>
          <tr><th>Employee</th><th>Period</th><th>Country</th><th>Approved by</th><th>Team Lead</th><th>Reward</th><th></th></tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id}>
              <td>{r.submitter?.name || '—'}</td>
              <td>{formatPeriodLabel(r.period, r.period_start, r.period_end)}</td>
              <td>{r.submitter?.countries?.name || '—'}</td>
              <td>{r.approvedByName || '—'}</td><td>{r.teamLeadName || '—'}</td>
              <td>{num(rewardOf(r)?.amount)}</td>
              <td><button type="button" className="btn-edit" onClick={() => onDetail(r)}>Details</button></td>
            </tr>
          ))}
        </tbody>
      </table>
      {pageCount > 1 && (
        <div className="pagination">
          <button type="button" className="btn-secondary" disabled={page === 0} onClick={() => onPage(page - 1)}>Prev</button>
          <span>Page {page + 1} of {pageCount}</span>
          <button type="button" className="btn-secondary" disabled={page + 1 >= pageCount} onClick={() => onPage(page + 1)}>Next</button>
        </div>
      )}
    </>
  );
}
